import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import axios from "axios";
import Skeleton from "react-loading-skeleton";

import "react-quill/dist/quill.snow.css";
import "react-loading-skeleton/dist/skeleton.css";
import { url } from "../constants/url";

const modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" }
    ],
    ["link", "image", "video"],
    ["clean"]
  ]
};

const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video"
];

const defaultPolicy = `...your default HTML here...`;

const PrivacyPolicyEditor = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  // Helper to grab our token header
  const authHeader = () => {
    const token = localStorage.getItem("token");
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  useEffect(() => {
    axios
      .get(`${url}/api/admin/privacy-policy`, {
        headers: {
          "Content-Type": "application/json",
          ...authHeader()
        }
      })
      .then((response) => {
        const policy = response.data.privacyPolicy;
        setContent(policy?.content ?? defaultPolicy);
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          localStorage.clear();
          navigate("/login");
        } else {
          console.error("Error fetching privacy policy:", error);
          setContent(defaultPolicy);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = () => {
    setSubmitting(true);
    axios
      .post(
        `${url}/api/admin/privacy-policy`,
        { content },
        { headers: { "Content-Type": "application/json", ...authHeader() } }
      )
      .then((response) => {
        setSubmitting(false);
        navigate("/policy-view", {
          state: { content: response.data.privacyPolicy.content }
        });
      })
      .catch((error) => {
        // Unauthorized → clear auth and redirect
        if (error.response?.status === 401) {
          localStorage.clear();
          navigate("/login");
          return;
        }

        console.error("Error saving privacy policy:", error);
        alert("There was an error saving the privacy policy.");
        setSubmitting(false);
      });
  };

  return (
    <div className="p-6 bg-white rounded-3xl shadow-md">
      <h1 className="text-3xl font-semibold mb-6 text-[#AF9C80]">
        Privacy Policy
      </h1>
      <div className="bg-gray-100 rounded-lg shadow-inner p-4 mb-4">
        {loading ? (
          <Skeleton height={400} />
        ) : (
          <ReactQuill
            value={content}
            onChange={setContent}
            modules={modules}
            formats={formats}
            style={{ height: "400px" }}
          />
        )}
      </div>
      <button
        onClick={handleSubmit}
        disabled={submitting || loading}
        className="mt-4 p-3 bg-[#AF9C80] text-white font-semibold rounded-3xl shadow-md hover:bg-[#8e7a61] focus:outline-none focus:ring focus:ring-[#AF9C80]"
      >
        {submitting ? "Saving..." : "Save Policy"}
      </button>
    </div>
  );
};

export default PrivacyPolicyEditor;
